(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["norvyra-home"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nv-product-carousel')) {
  customElements.define('nv-product-carousel', class extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.nv-carousel-track');
      this.slides = [...this.querySelectorAll('.nv-carousel-slide')];
      if (this.slides.length < 2) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reduced.matches;
      this.index = 0;
      this.querySelector('.nv-carousel-controls').hidden = false;
      this.toggle = this.querySelector('[data-toggle]');
      this.update();
      this.querySelector('[data-prev]').addEventListener('click', () => this.move(-1, true), options);
      this.querySelector('[data-next]').addEventListener('click', () => this.move(1, true), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.update(); this.schedule(); }, options);
      this.track.addEventListener('scroll', () => {
        this.index = Math.round(this.track.scrollLeft / this.track.clientWidth);
        this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
      }, options);
      this.track.addEventListener('pointerdown', () => { this.paused = true; this.update(); this.schedule(); }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', event => { if (event.target === this.toggle) { clearTimeout(this.timer); return; } this.paused = true; this.update(); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reduced.addEventListener('change', () => { if (this.reduced.matches) this.paused = true; this.update(); this.schedule(); }, options);
      this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.schedule(); }, {threshold: .2});
      this.observer.observe(this);
    }
    update() {
      this.toggle.textContent = this.paused ? this.dataset.play : this.dataset.pause;
      this.querySelector('[data-count]').textContent = `${this.index + 1} / ${this.slides.length}`;
    }
    move(direction, manual = false) {
      if (manual) this.paused = true;
      this.index = (this.index + direction + this.slides.length) % this.slides.length;
      this.track.scrollTo({left: this.index * this.track.clientWidth, behavior: this.reduced.matches ? 'instant' : 'smooth'});
      this.update();
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (!this.paused && !this.hovered && this.visible && !document.hidden) this.timer = setTimeout(() => this.move(1), 6000);
    }
    disconnectedCallback() { clearTimeout(this.timer); this.abort?.abort(); this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
